/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';


export interface SearchUsersMatchingDto { 
    sportType: SearchUsersMatchingDto.SportTypeEnum;
    location: GeoLocationEntity;
    addressName?: string;
    distance?: number;
    limit?: number;
}
export namespace SearchUsersMatchingDto {
    export type SportTypeEnum = 'football' | 'triathlon' | 'bike' | 'run';
    export const SportTypeEnum = {
        Football: 'football' as SportTypeEnum,
        Triathlon: 'triathlon' as SportTypeEnum,
        Bike: 'bike' as SportTypeEnum,
        Run: 'run' as SportTypeEnum
    };
}


